import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import Card from '@material-ui/core/Card';

import { colors } from 'styles/theme';

import Link from '../Link/Link';

const cardCss = css`
  &.MuiCard-root {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: ${colors.textColor};
  }
`;

function PromoBase({ children, linkHref, linkAs, className }) {
  return (
    <Link href={linkHref} as={linkAs}>
      <Card className={className} css={cardCss} component="article">
        {children}
      </Card>
    </Link>
  );
}

PromoBase.propTypes = {
  linkHref: PropTypes.string.isRequired,
  children: PropTypes.node,
  linkAs: PropTypes.string,
  className: PropTypes.string,
};

export default PromoBase;
